export const ADD_SHOT = "s";
export const ADD_NOTE = "n";

export const PLAY_PAUSE = "space";
export const REWIND_10 = "shift+left";
export const REWIND_5 = "left";
export const FAST_FORWARD_5 = "right";
export const FAST_FORWARD_10 = "shift+right";
